<template>
  <loading-spinner ref="spinner" spinnerType="border" color="primary" />
  <!-- Loading -->
  <div
    id="loading"
    class="mt-5"
    :class="enableLoading ? 'loadingTable' : ''"
    v-if="enableLoading"
  >
    <h4 class="">
      <i class="fi fi-orbit fi-spin"></i>
    </h4>
  </div>
  <div v-if="!enableLoading">
    <div class="mb-2">
      <div v-if="siteClientReserveSessions.length != 0">
        <template v-if="!hasSessionToReplace()">
          <p class="my-0">زمان موردنظر خود را انتخاب کنید:</p>
          <!-- <p class="my-0" v-if="getBackRoutFrom() != 'selectTestSession'">
            <i class="fi fi-round-info-full text-danger-gradient blinkText"></i>
            شما می‌توانید هر تعداد جلسه‌ای که نیاز دارید را در این هفته یا
            هفته‌های آتی تنظیم نمایید.
          </p> -->
        </template>
        <p v-else>لطفا روز و ساعت مورد نظر خود را انتخاب نمایید.</p>
      </div>

      <div v-if="siteClientReserveSessions.length == 0 && weekNumber != 8">
        <p class="alert alert-warning mt-2" :class="isMobile ? ' fs15px' : ''">
          <span
            class="spinner-grow spinner-grow-sm"
            role="status"
            aria-hidden="true"
          ></span>
          در هفته‌ی جاری جلسه‌ای با مشخصات مورد نظر شما موجود نیست. لطفاً
          <b> هفته‌های آینده </b>
          را بررسی نمایید.
        </p>
      </div>
    </div>
    <div class="shadow-lg" :class="isMobile ? 'my-4' : ''">
      <div class="d-flex justify-content-between weekPanel p-1">
        <div>
          <a
            href="#"
            @click="() => (weekNumber == 0 ? weekNumber : weekNumber--)"
            :class="weekNumber == 0 ? 'disabled' : ''"
            class="text-decoration-none btn btn-sm p-1 btn-danger fs13px collapsed"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="accordionAccountSignIn"
            ><svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-arrow-right-circle-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"
              ></path>
            </svg>
            هفته قبل
          </a>
          <a
            href="#"
            @click="() => (weekNumber = 0)"
            :class="weekNumber == 0 ? 'disabled' : ''"
            class="text-decoration-none btn btn-sm p-1 bg-white text-blueSite fs13px collapsed d-md-inline-block d-sm-none"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="accordionAccountSignIn"
            ><svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-play-circle"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
              ></path>
              <path
                d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"
              ></path>
            </svg>
            {{ isMobile ? '' : 'هفته جاری' }}
          </a>
        </div>
        <div>
          <span class="text-white fw-medium">{{
            weekNumber == 0
              ? 'هفته جاری'
              : `${getWeekWord(weekNumber)} هفته بعد`
          }}</span>
        </div>
        <div>
          <a
            href="#"
            @click="() => (weekNumber == 8 ? weekNumber : weekNumber++)"
            :class="weekNumber == 8 ? 'disabled' : ''"
            class="text-decoration-none btn btn-sm p-1 btn-success text-light fs13px collapsed"
            data-bs-toggle="collapse"
            aria-expanded="false"
            aria-controls="accordionAccountSignIn"
          >
            هفته بعد
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-arrow-left-circle-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"
              ></path>
            </svg>
          </a>
        </div>
      </div>
      <session-reserving-table
        :headerList="headerList"
        :siteClientReserveSessions="siteClientReserveSessions"
        :isOnlineSessions="entityObject.sessionTypeID == '1' ? false : true"
        :entityObject="entityObject"
      />
    </div>
    <div>
      <p class="text-justified mt-1">
        <i class="fi fi-round-info-full text-danger-gradient blinkText"></i>
        <template v-if="$store.getters.isOverseas">
          در صورت مواجهه با هر مشکلی به شماره
          <a href="tel:+98 903 130 9156" class="text-blueSite text-dashed"
            >00989031309156</a
          >
          در واتس‌اپ پیام بدهید.
        </template>
        <template v-else>
          در صورت نیاز به راهنمایی
          <!-- <template v-if="getBackRoutFrom() == 'selectTestSession'">
            تست
          </template>
          <template v-else> جلسه </template> -->
          لطفا با شماره
          <a href="tel:۰۲۱-۹۱۰۰۵۱۴۱" class="text-blueSite text-dashed"
            >۹۱۰۰۵۱۴۱-۰۲۱</a
          >
          تماس حاصل فرمایید.
        </template>
      </p>
    </div>
    <!-- <button
      type="button"
      class="btn p-1 btn-sm text-dark btn-warning"
      @click="informationButton"
    >
      راهنما
    </button> -->
    <!-- <div
      v-if="isShowAlertInformation"
      class="row alert alert-warning alert-dismissible fade show mx-2 mt-1"
      role="alert"
    >
      <template v-if="entityObject.sessionTypeID == '1'">
        <div class="col-md-6 col-12 text-md-center text-end">
          <b> صبح: </b>
          از بازه زمانی ۹ صبح تا ساعت 15
        </div>
        <div class="col-md-6 col-12">
          <b> عصر: </b>
          از ساعت ۱۵ تا ساعت ۲۱
        </div>
      </template>
      <template v-else>
        <div class="col-md-6 col-12">
          <b> صبح: </b>
          از بازه زمانی 8 صبح تا ساعت 11
        </div>
        <div class="col-md-6 col-12">
          <b> ظهر: </b>
          از ساعت 11 صبح تا 16
        </div>
        <div class="col-md-6 col-12">
          <b> عصر: </b>
          از ساعت 16 تا 21
        </div>
        <div class="col-md-6 col-12">
          <b> شب: </b>
          شب از ساعت 21 تا 24
        </div>
      </template>
      <button
        @click="dismissInformation"
        type="button"
        class="btn-close"
      ></button>
    </div> -->
  </div>

  <p
    class="alert alert-danger mt-2"
    v-if="showEmergencySessionButton && checkTestAndSessionType()"
    :class="isMobile ? ' fs15px' : ''"
  >
    <!-- <i class="fi fi-circle-spin fi-spin fs-4"></i> -->
    <span
      class="spinner-grow spinner-grow-sm"
      role="status"
      aria-hidden="true"
    ></span>
    جلسه‌ای با مشخصات مورد نظر شما در دسترس نیست. در صورت نیاز می توانید درخواست
    جلسه
    <b> اورژانسی </b>
    نمایید.
  </p>
  <div
    class="d-flex justify-content-between"
    :class="isMobile && showEmergencySessionButton ? 'text-center' : 'd-flex'"
  >
    <div class="previousStepRight" v-if="isMobile ? !enableLoading : true">
      <button class="btn btn-sm my-2" @click="previousTab()">
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-arrow-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
          ></path>
        </svg>
        <span> گام قبلی </span>
      </button>

      <a
        class="btn btn-sm rounded btn-danger m-0 animate-pulse m-2 position-relative"
        :class="isMobile ? '' : 'float-end'"
        v-if="showEmergencySessionButton && checkTestAndSessionType()"
        @click="goToEmergancySession"
      >
        <!-- :href="`/panel/emergencySessionTab/${}`" -->
        <i class="fi fi-support-1"></i>

        جلسه اورژانسی
      </a>
    </div>
    <div class="nextStepLeft">
      <button
        class="btn btn-sm btn-outline-danger my-2"
        @click="showCancelReplacingModal()"
        v-if="hasSessionToReplace()"
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-x-lg"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
          ></path>
          <path
            fill-rule="evenodd"
            d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
          ></path>
        </svg>
        لغو عملیات جابجایی
      </button>
      <button
        class="btn btn-sm btn-danger my-2"
        @click="nextTab()"
        v-if="semiReserveListCount() != 0"
      >
        <svg
          width="16px"
          height="16px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-check-circle-fill ms-1"
          viewBox="0 0 16 16"
        >
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"
          ></path>
        </svg>
        ثبت
      </button>
    </div>
  </div>
</template>
<script>
import SessionReservingTable from '../../../../../components/form/table/sessionReservingTable/SessionReservingTable.vue';
import LoadingSpinner from '../../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
export default {
  components: {
    SessionReservingTable,
    LoadingSpinner,
  },
  provide() {
    return {
      refreshTableWithTherapistFilter: this.refreshTableWithTherapistFilter,
    };
  },
  inject: [
    'previousStep',
    'nextStep',
    'semiReserveListCount',
    'hasSessionToReplace',
    'showCancelReplacingModal',
    'getBackRoutFrom',
  ],
  data() {
    return {
      isMobile: isMobile,
      isOnlineSessions: false,
      weekNumber: 0,
      headerList: [],
      enableLoading: true,
      showEmergencySessionButton: false,
      siteClientReserveSessions: [],
      isShowAlertInformation: false,
    };
  },
  props: {
    entityObject: {
      sessionTypeID: 0,
      educationID: null,
      genderID: null,
      therapistID: null,
      ageRangeID: null,
      therapyTypeID: null,
      therapyTypeTitle: '',
      scopeIDs: [],
      topicIDs: [],
      approachIDs: [],
      otherAbilityIDs: [],
      personID: 0,
      isOverseas: false,
    },
  },
  watch: {
    weekNumber: async function () {
      this.enableLoading = true;
      await this.getReserveSchedulingHeader();
      await this.getSiteSessionsByTimeType();
      this.enableLoading = false;
    },
    enableLoading: function () {
      /* eslint-disable */
      var tooltipTriggerList = [].slice.call(
        document.querySelectorAll('[data-bs-toggle="tooltip"]')
      );
      var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl);
      });
    },
  },
  methods: {
    dismissInformation() {
      this.isShowAlertInformation = false;
      let rightDiv = document.getElementsByClassName('bg-RightMenu')[0];
      if (rightDiv) rightDiv.style.minHeight = 'max(700px, 80vh)';
    },
    informationButton() {
      this.isShowAlertInformation = true;
      let rightDiv = document.getElementsByClassName('bg-RightMenu')[0];
      if (rightDiv) rightDiv.style.minHeight = '85vh';
    },
    checkTestAndSessionType() {
      if (this.getBackRoutFrom() == 'selectTestSession') return false;
      else return true;
    },
    getWeekWord(weekNumber) {
      let weekWord;
      switch (weekNumber) {
        case 1:
          weekWord = 'یک';
          break;
        case 2:
          weekWord = 'دو';
          break;
        case 3:
          weekWord = 'سه';
          break;
        case 4:
          weekWord = 'چهار';
          break;
        case 5:
          weekWord = 'پنج';
          break;
        case 6:
          weekWord = 'شش';
          break;
        case 7:
          weekWord = 'هفت';
          break;
        case 8:
          weekWord = 'هشت';
          break;
        default:
          weekWord = weekNumber;
          break;
      }
      return weekWord;
    },
    async refreshTableWithTherapistFilter() {
      this.$refs.spinner.show();
      await this.getSiteSessionsByTimeType();
      this.$refs.spinner.hide();
    },
    goToEmergancySession() {
      this.$router.push({
        name: 'emergencySessionTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    showEmergencyTooltip(event) {
      event.stopPropagation();
    },
    nextTab() {
      let rightDiv = document.getElementsByClassName('bg-RightMenu')[0];
      if (rightDiv) rightDiv.style.minHeight = 'max(700px, 80vh)';
      this.nextStep(null, 'sessionTableView');
    },
    previousTab() {
      let rightDiv = document.getElementsByClassName('bg-RightMenu')[0];
      if (rightDiv) rightDiv.style.minHeight = 'max(700px, 80vh)';
      this.previousStep('sessionTableView');
    },
    async getReserveSchedulingHeader() {
      let that = this;
      await axios
        .get(
          that.$store.state.apiBaseURL +
            `/CLC/Session/GetWeeklyScheduleHeader?weekNumber=${this.weekNumber}`
        )
        .then((response) => {
          that.headerList = response.data;
        })
        .catch(() => {});
    },
    async getSiteSessionsByTimeType() {
      let that = this;
      let therapistID = this.entityObject.therapistID;
      //اگر کاربر بخواهد جلسه گرفتن با این درمانگر را ادامه دهد، فیلتر این درمانگر روی هفته ها اعمال شود
      if (sessionStorage.getItem('lockedTherapistID'))
        therapistID = sessionStorage.getItem('lockedTherapistID');
      let sendModel;
      if (that.entityObject.sessionTypeID == 0) {
        if (that.$store.getters.getFilterForPreReserving)
          sendModel = new Object({
            weekNumber: 0,
            sessionTypeID:
              that.$store.getters.getFilterForPreReserving?.sessionTypeID ?? 0,
            educationID: null,
            genderID: null,
            therapistID: null,
            ageRangeID: null,
            therapyTypeID:
              that.$store.getters.getFilterForPreReserving.therapyTypeID,
            scopeIDs: that.$store.getters.getFilterForPreReserving.scopeIDs,
            topicIDs: [],
            approachIDs: [],
            otherAbilityIDs: [],
            personID: that.$store.getters.userPersonID,
            isOverseas: that.$store.getters.isOverseas,
          });
        else {
          sendModel = new Object({
            weekNumber: 0,
            sessionTypeID:
              that.$store.getters.getFilterForPreTestReserving?.sessionTypeID ??
              0,
            educationID: null,
            genderID: null,
            therapistID: null,
            ageRangeID: null,
            therapyTypeID: 14,
            scopeIDs: [7],
            topicIDs: [
              that.$store.getters.getFilterForPreTestReserving.testTypeID,
            ],
            approachIDs: [],
            otherAbilityIDs: [],
            personID: that.$store.getters.userPersonID,
            isOverseas: that.$store.getters.isOverseas,
          });
        }
      } else {
        sendModel = new Object({
          weekNumber: that.weekNumber,
          sessionTypeID: that.entityObject.sessionTypeID,
          educationID: that.entityObject.educationID,
          genderID: that.entityObject.genderID,
          therapistID: therapistID,
          ageRangeID: that.entityObject.ageRangeID,
          therapyTypeID: that.entityObject.therapyTypeID,
          scopeIDs: that.entityObject.scopeIDs,
          topicIDs: that.entityObject.topicIDs,
          approachIDs: that.entityObject.approachIDs,
          otherAbilityIDs: that.entityObject.otherAbilityIDs,
          personID: that.entityObject.personID,
          isOverseas:
            that.entityObject.isOverseas ?? that.$store.getters.isOverseas,
        });
      }

      if (sendModel.sessionTypeID == 0) return;
      if (!sendModel.sessionTypeID) return;
      await axios
        .post(
          that.$store.state.apiBaseURL +
            '/CLC/Session/GetSiteSessionsByTimeType',
          sendModel
        )
        .then((response) => {
          that.siteClientReserveSessions = response.data;
          that.showEmergencySessionButton =
            that.siteClientReserveSessions.length == 0;
        })
        .catch(() => {});
    },
  },
  async beforeMount() {
    sessionStorage.removeItem('lockedTherapistID');
    if (this.semiReserveListCount() != 0 && this.hasSessionToReplace()) {
      this.enableLoading = false;
      return;
    }
    await this.getReserveSchedulingHeader();
    await this.getSiteSessionsByTimeType();
    this.enableLoading = false;
  },
};
</script>

<style scoped>
#loading {
  transition: opacity 0.5s ease;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  text-align: center;
  opacity: 0.7;
  color: #4c5e74;
  background-color: transparent;
  z-index: 99;
}
.weekPanel {
  background-color: #4c5e74;
  padding: 5px 15px;
}
.loadingTable {
  min-height: 45vh;
  display: flex !important;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
</style>

<style>
.tooltip {
  --bs-tooltip-bg: #fad776;
  --bs-tooltip-color: #303030;
  --bs-tooltip-font-size: 0.775rem;
  font-family: Vazir;
}
</style>
